<form autocomplete="off" [formGroup]="financialYearForm" (ngSubmit)="upsert()" (keydown.enter)="useEnterKey ? $event.preventDefault() : upsert()">

    <div class="row">
        <div class="col-md-2">
            <div class="mb-2">
                <label for="fromDate" class="form-label">From Date</label>
                <input id="fromDate" type="date" class="form-control form-control-sm" formControlName="ddlFromDate"  placeholder="Select"
                    [ngClass]="{'is-invalid': (financialYearForm.get('ddlFromDate').touched) && financialYearForm.get('ddlFromDate').errors}" >
                <div *ngIf="(financialYearForm.get('ddlFromDate').touched) && financialYearForm.get('ddlFromDate').errors" class="invalid-feedback">
                    <span *ngIf="financialYearForm.get('ddlFromDate').errors.required">From Date</span>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="mb-2">
                <label for="toDate" class="form-label">To Date</label>
                <input id="toDate" type="date" class="form-control form-control-sm" formControlName="ddlToDate"  placeholder="Select"
                    [ngClass]="{'is-invalid': (financialYearForm.get('ddlToDate').touched) && financialYearForm.get('ddlToDate').errors}" >
                <div *ngIf="(financialYearForm.get('ddlToDate').touched) && financialYearForm.get('ddlToDate').errors" class="invalid-feedback">
                    <span *ngIf="financialYearForm.get('ddlToDate').errors.required">To Date</span>
                </div>
            </div>
        </div>
        <div class="col-md-2 mt-3">
        <button type="button" class="btn btn-primary btn-sm ml-8 mt-1" (click)="upsert()" (keydown.enter)="useEnterKey ? $event.preventDefault() : upsert()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>{{ editMode ? 'Update' : ' Add' }}
          </button>
        </div>
        <div class="row">
            <div class="col-md-12 grid-container">
              <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                [defaultColDef]="defaultColDef"[gridOptions]="gridOptions" [suppressMenuHide]="true"  [pagination]="true" (gridReady)="onGridReady($event)">
              </ag-grid-angular>
            </div>
          </div>
    </div>
</form>
